import React, { useEffect, useState } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { NavBar } from "./NavBar";
import { navigationStore } from "../../../app/stores/Navigation";
import { NavScreenComponent } from "../NavScreenComponent";
import Animated from "react-native-reanimated";
import { Footer } from "../../Footer";

const Stack = createStackNavigator();

export const BarNavigation = () => {
	const nav = navigationStore((state) => state);
	return (
		<>
			<NavBar
				align="center"
				screens={nav.navItemList}
			/>
			<Stack.Navigator
				initialRouteName={nav.currentScreen.toString()}
				screenOptions={{
					headerShown: false,
					animationEnabled: true,
					animationTypeForReplace: "pop",
				}}
			>
				{nav.screenList.map((screen, index) => {
					return (
						<Stack.Screen
							key={index}
							name={screen.toString()}
							component={NavScreenComponent(screen)}
							options={{ title: screen.replaceAll("_", " ").toString() }}
							// initialParams={{ screenName: screen }}
						/>
					);
				})}
			</Stack.Navigator>
		</>
	);
};
